import memoize from "memoize-one";
const splitWithIndex = memoize((str, delim) => {
  const result = [];
  const splits = str.split(delim);
  let index = 0;
  for (let i = 0; i < splits.length; i++) {
    if (splits[i]) {
      result.unshift([index, splits[i] && splits[i].replaceAll ? splits[i].replaceAll(/[ .,:;!?\-"'»«)(]/g, "") : splits[i]]);
    }
    index += splits[i].length + delim.length;
  }
  return result;
});
export default splitWithIndex;
//# sourceMappingURL=splitWithIndex.js.map